import styled from 'styled-components';

export default styled.div`
  position: relative;
  animation: sk-rotate 2s infinite linear;
  width: 40px;
  height: 40px;
  text-align: center;
`;
